<template>
  <v-container fluid fill-height>
    <v-row justify="start">
      <v-btn class="ma-2 ml-12 mt-12 mb-12" color="#041a41" @click="goToHome">
        <v-icon color="white" left>mdi-arrow-left
        </v-icon>
        <h3 style="color: white;">Voltar Para Pagina Inicial</h3>
      </v-btn>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" lg="6">
        <v-row class="mb-4">
          <v-col>
            <h2 class="text-center">
              Queremos que você aproveite ao máximo o sistema, preencha o formulário para fazer o download e receber informações e novidades sobre o Policorp Linux.
            </h2>
          </v-col>
        </v-row>

        <v-form v-if="!submited" v-model="form" @submit.prevent="submitForm">
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="formData.nome" label="Nome" :rules="[required]"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="formData.email" :readonly="loading" :rules="[required]" class="mb-2" label="Email"
                clearable></v-text-field>
            </v-col>
            </v-row>
          <v-row>
            <v-col align="center" cols="12" class="mb-12">
              <v-btn type="submit" color="primary">Enviar</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <div v-else>
            <h1>O download não iniciou? Tente novamente clicando <a :href="downloadLink" download>aqui</a></h1>
        </div>
      </v-col>
    </v-row>

        <v-row class="d-flex justify-center overflow-auto recommended">
      <v-col cols="12">
        <v-card class="elevation-10 mb-6">
          <v-card-title class="headline text-center">MD5 da ISO policorp-13.1-amd64.iso</v-card-title>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>MD5 Hash</v-list-item-title>
                <v-list-item-subtitle>d0620cb9695e95ca9290e3b1012e07e9</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center overflow-auto recommended">
      <v-col cols="12" md="6">
        <v-card class="elevation-10 mb-6">
          <v-card-title class="headline text-center">Requisitos Mínimos</v-card-title>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Processador</v-list-item-title>
                <v-list-item-subtitle>1 GHz Dual Core - Intel/AMD64-bit</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>RAM</v-list-item-title>
                <v-list-item-subtitle>4 GB RAM</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Armazenamento</v-list-item-title>
                <v-list-item-subtitle>20 GB</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="elevation-10 mb-6">
          <v-card-title class="headline text-center">Requisitos Recomendados</v-card-title>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Processador</v-list-item-title>
                <v-list-item-subtitle>2 GHz processador dual-core </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>RAM</v-list-item-title>
                <v-list-item-subtitle>8 GB RAM</v-list-item-subtitle>
              </v-list-item-content> 
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Armazenamento</v-list-item-title>
                <v-list-item-subtitle>SSD com 32 GB de disco</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="4" class="text-center">
        <v-hover v-slot:default="{ hover }">
          <v-card class="card" :class="{ up: hover }">
            <v-img :src="image" max-width="100px" class="d-block ml-auto mr-auto iso-info"
              :class="{ 'zoom-effect': hover }">
            </v-img>
            <h2 class="mt-4">Sobre o Sistema</h2>
            <h3 class="mt-4">Kernel</h3>
            <span class="mt-4">6.6</span>
            <h3 class="mt-4">Tamanho</h3>
            <span class="mt-4 pb-12">3.6 GB</span>
            <h3 class="mt-4">MD5SUM</h3>
            <span class="mt-4 ">d0620cb9695e95ca9290e3b1012e07e9 </span>

          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import axios from "@/utils/axios"

export default defineComponent({
  data() {
    return {
      form: false,
      submited: false,
      downloadLink: 'policorp-13.1-amd64.iso',
      formData: {
        nome: '',
        email: '',
        ddd: '', // MANTIDO AQUI
        telefone: '', // MANTIDO AQUI
        mensagem: ''
      },
      image: require('@/assets/computer.png')
    };
  },
  methods: {
    // Regra dddValidationRule não é mais necessária visualmente, mas pode manter
    dddValidationRule(v) {
      return /^\d{2}$/.test(v) || 'DDD inválido'
    },
    required(v) {
      return !!v || 'Preencha o Campo'
    },
    goToHome() {
      this.$router.go(-1);
    },
    submitForm() {
      if (!this.form) return
      this.submited = true
      // O this.formData já contém ddd: '' e telefone: ''
      axios.post('/api/customers-linux', this.formData) 
        .then(response => {
          console.log('Form submitted successfully:', response.data);
          const link = document.createElement('a');
          link.href = 'policorp-13.1-amd64.iso'; // Set the file path here
          link.setAttribute('policorp-13.1-amd64.iso'); // Set the file name here
          link.click();
        })
        .catch(error => {
          console.error('Error submitting form:', error);
          const message = 'Algo deu errado ao fazer a solicitação da imagem. Tente novamente.';
          window.alert(message);
        });
    },
    // Função filter não é mais necessária para ddd/telefone, mas pode manter
    filter: function (evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
});
</script>
<style scoped>
/* Estilos permanecem os mesmos */
.recommended {
  margin-left: 3vw;
  margin-right: 3vw;
}

.recommended .v-list-item__subtitle {
  white-space: unset;
}

.card {
  transition: all 0.3s ease-in-out;
  padding: 15px;
}

.zoom-effect {
  transform: scale(1.1);
}

.iso-info {
  color: black;

}

.text-center{
  color: gray
}
</style>